<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="프로모션">
                <div class="">
                    <div class="">
                        <div class="table-responsive p-0">
                            <table class="table table-hover text-nowrap text-center">
                                <thead>
                                    <tr>
                                        <th class="width15">프로모션 코드</th>
                                        <th>제목</th>
                                        <th class="width15">전시 기간</th>
                                        <th class="width10">전시 상태</th>
                                        <th class="width7">노출 순서</th>
                                        <th class="width5">삭제</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,idx) in promotionList" :key="idx">
                                        <td>{{ item.promotionId }}</td>
                                        <td class="cls_click text-center" @click="edtPromotion(item.promotionId)"> <a class="cls_click">{{ item.title }}</a> </td>
                                        <td>{{ item.startDate +'~' +item.endDate }} </td>
                                        <td class="linkcmp text-center" style="display: inline-flex;width:100%;justify-content: center;" @click="onChangeStatus(item.status, idx,item.promotionId)">
                                            <ToggleBtn class="mt-2" :value="item.status" />
                                        </td>
                                        <td>
                                            <drop @drop="handleDrop(item, $event)">
                                                <drag class="btn btn-default btn-social-icon cursorMove" :transfer-data="{ item: item, index: idx}">
                                                    <div style="font-size: 1.4rem;">
                                                        <b-icon-arrows-expand></b-icon-arrows-expand>
                                                    </div>
                                                </drag>
                                            </drop>
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-social-icon" @click="delpromotion(item.promotionId)">
                                                <b-icon-trash></b-icon-trash>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="jetpo">
                            <span>* 전시중인 프로모션 중 첫번째 항목이 대표 프로모션으로 노출됩니다.</span>
                            <button type="button" class="btn top-right-button btn-outline-success" @click="promotionModalOpen">프로모션 만들기</button>
                        </div>
                    </div>

                    <!-- 모달 -->
                    <div class="modal" :style="promotionModal && {'display': 'block'}">
                        <div class="modal-dialog maxwid">
                            <div class="modal-content">
                                <div class="modal-header"> {{ promotionModalName }} </div>
                                <div class="modal-body form-horizontal">
                                    <!-- 시간 선택 박스 -->
                                    <div class="row">
                                        <div class="col-sm-2">제목 *</div>
                                        <div class="col-sm-10">
                                            <input type="text" v-model="title" class="form-control">
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-sm-2">내용 *</div>
                                        <div class="col-sm-10">
                                            <textarea v-model="description" class="form-control txtaH"></textarea>
                                        </div>
                                    </div>

                                    <div class="row mt-4">
                                        <div class="col-sm-2">전시 기간 *</div>
                                        <div class="col-sm-10">
                                            <b-row class="pl-3">
                                                <div class="form-group has-float-label">
                                                    <b-input-group>
                                                        <v-date-picker mode="single" v-model="temp.startDate" :input-props="{ class:'form-control', placeholder: '' }"></v-date-picker>
                                                        <template v-slot:append>
                                                            <b-input-group-text>
                                                                <b-icon icon="calendar"></b-icon>
                                                            </b-input-group-text>
                                                        </template>
                                                    </b-input-group>
                                                    <span>시작날짜</span>
                                                </div>
                                                <span class="" style="border:none;display:inline-flex">-</span>
                                                <div class="form-group has-float-label">
                                                    <b-input-group>
                                                        <v-date-picker mode="single" v-model="temp.endDate" :input-props="{ class:'form-control', placeholder: ''}"></v-date-picker>
                                                        <template v-slot:append>
                                                            <b-input-group-text>
                                                                <b-icon icon="calendar"></b-icon>
                                                            </b-input-group-text>
                                                        </template>
                                                    </b-input-group>
                                                    <span>종료날짜</span>
                                                </div>
                                            </b-row>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-sm-2">이미지</div>
                                        <div class="col-sm-3">
                                            <!-- <SingleThumbnail v-model="mainImageurl" :imgtype="imgtype.STORE" :change="onMainImage" :imgFile="{}" /> -->
                                            <div style="max-width: 164px;">
                                                <sortable-file-uploader :Reflect="ReflectVal" :sortable="'hold'" :container="'STORE'" :compact="true" :maxFiles="1" :defaultFiles="mainImageurl" @getFileData="onMainImage"></sortable-file-uploader>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="modal-footer text-center">
                                    <button type="button" class="btn btn-outline-primary" @click="promotionModalClose">취소</button>
                                    <button type="button" class="btn btn-primary" @click="promotionModalSave(false)" v-if="!proedt">저장</button>
                                    <button type="button" class="btn btn-primary" @click="promotionModalSave(true)" v-if="proedt">수정</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 모달 end -->

                </div>
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import SortableFileUploader from "../../components/Upload/SortableFileUploader";
import api from "../../constants/api";
import ToggleBtn from './ToggleBtn';
const now = new Date()
import {
    Drag,
    Drop
} from "vue-drag-drop";

import {
    rescode,
} from "../../constants/common";
import {
    reqGet,
    reqPost
} from "../../constants/request";

import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    components: {
        // SingleThumbnail,
        'sortable-file-uploader': SortableFileUploader,
        ToggleBtn,
        Drag,
        Drop
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    data() {
        return {
            ReflectVal: null,
            temp: {
                startDate: '',
                endDate: '',
            },
            proedt: false,
            promotionModalName: '',
            promotionModal: false,
            description: "",
            title: "",
            mainImageurl: "",
            image: {},
            promotionList: [],
            promotionId: "",
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        delpromotion(promotionId) {
            if (confirm("삭제하시겠습니까? 삭제된 프로모션은 되돌릴 수 없습니다.")) {
                reqPost(
                    this.requrlChange(api.shop.storePromotionDeleteBRD, api.shop.storePromotionDeleteSTR, '', ''),
                    this.currentUser.tokens.access.token, {
                        promotionId: promotionId,
                        storeCode: this.$route.params.storeCode,
                    },
                    (result) => {
                        if (result != null) {
                            if (result.code == rescode.REQ_SUCCESS) {
                                alert("삭제되었습니다.");
                                this.refresh();
                            } else {
                                alert(result.message);
                            }
                        }
                    }
                );
            }
        },
        edtPromotion(promotionId) {
            this.promotionModalName = '프로모션 수정';
            this.promotionModal = true;
            this.proedt = true;
            this.promotionId = promotionId;
            reqGet(
                this.requrlChange(api.shop.storePromotionQueryBRD, api.shop.storePromotionQuerySTR, "?storeCode=" + this.$route.params.storeCode + "&promotionId=" + promotionId, "?promotionId=" + promotionId),
                this.currentUser.tokens.access.token,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.title = result.data.title;
                            this.description = result.data.description;
                            this.temp.startDate = new Date(result.data.startDate);
                            this.temp.endDate = new Date(result.data.endDate);
                            // console.log(this.temp.endDate)
                            let faks = [];
                            if (result.data.promotionImage !== null) {
                                faks.push({ // 파일 특성상 가짜 이름과 타입 사이트 지정
                                    name: "TestName.jpg",
                                    size: 2000,
                                    type: "image/jpeg",
                                    ext: "jpg",
                                    url: result.data.promotionImage !== null ? result.data.promotionImage.url : "",
                                })
                            }



                            this.mainImageurl = result.data.promotionImage !== null ? result.data.promotionImage.url : '';
                            if(result.data.promotionImage.url){
                                this.ReflectVal = faks;
                            }else{
                                this.ReflectVal = [];
                            }
                            this.image = {
                                "url": result.data.promotionImage !== null ? result.data.promotionImage.url : '',
                                "width": result.data.promotionImage !== null ? result.data.promotionImage.width : '',
                                "height": result.data.promotionImage !== null ? result.data.promotionImage.height : '',
                                "description": result.data.promotionImage !== null ? result.data.promotionImage.description : '',
                            }
                            console.log(faks)
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        handleDrop(myitem, drag) {
            var priorities = [];
            priorities.push({
                promotionId: drag.item.promotionId,
                priority: myitem.priority
            });
            priorities.push({
                promotionId: myitem.promotionId,
                priority: drag.item.priority
            });
            reqPost(
                this.requrlChange(api.shop.storePromotionPriorityBRD, api.shop.storePromotionPrioritySTR, '', ''),
                this.currentUser.tokens.access.token, {
                    storeCode: this.$route.params.storeCode,
                    priorities: priorities,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.refresh();
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        onChangeStatus(status, midx, promotionId) {
            var url = '';
            if (!status) {
                url = this.requrlChange(api.shop.storePromotionEnableBRD, api.shop.storePromotionEnableSTR, '', '');
            } else {
                url = this.requrlChange(api.shop.storePromotionDisableBRD, api.shop.storePromotionDisableSTR, '', '');
            }
            reqPost(
                url,
                this.currentUser.tokens.access.token, {
                    storeCode: this.$route.params.storeCode,
                    promotionId: promotionId,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.promotionList[midx].status = !status;
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        refresh() {
            // console.log(this.$route.params.storeCode)
            reqGet(
                this.requrlChange(api.shop.storePromotionListBRD, api.shop.storePromotionListSTR, "?storeCode=" + this.$route.params.storeCode, ''),
                this.currentUser.tokens.access.token,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.promotionList = result.data.list;
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        promotionModalOpen() {
            this.promotionModalName = '프로모션 만들기';
            this.promotionModal = true;
            this.proedt = false;
            this.title = '';
            this.description = '';
            this.temp.startDate = '';
            this.temp.endDate = '';
            this.mainImageurl = null;
            this.ReflectVal = null
            this.image = {}
        },
        onMainImage(file) {
            if (file.length > 0) {
                let _url = file[0].azureUrl ? file[0].azureUrl : file[0].url;
                this.mainImageurl = _url;
                this.image = {
                    width: file[0].width,
                    height: file[0].height,
                    url: _url,
                    azureUrl: _url,
                    "description": null
                }
            } else {
                this.mainImageurl = null
            }
        },
        promotionModalClose() {
            this.promotionModal = false;
        },
        promotionModalSave(edt) {
            if (this.title === '') {
                alert('제목을 입력해주세요');
                return;
            }
            if (this.description === '') {
                alert('내용을 입력해주세요');
                return;
            }
            if (this.temp.startDate === '' || this.temp.endDate === '') {
                alert('전시기간을 입력해주세요');
                return;
            }
            if (new Date(this.temp.startDate) > new Date(this.temp.endDate)) {
                alert('시작일이 종료일보다 클 수 없습니다.');
                return;
            }
            let url = '';
            let dd = {};
            if (edt) {

                url = this.requrlChange(api.shop.storePromotionUpdateBRD, api.shop.storePromotionUpdateSTR, '', '');
                dd = {
                    "promotion": {
                        "title": this.title,
                        "description": this.description,
                        "startDate": this.$moment(this.temp.startDate).format('YYYY-MM-DD'),
                        "endDate": this.$moment(this.temp.endDate).format('YYYY-MM-DD'),
                        "image": this.image,
                    },
                    'promotionId': this.promotionId,
                    "storeCode": this.$route.params.storeCode,
                }
            } else {

                url = this.requrlChange(api.shop.storePromotionCreateBRD, api.shop.storePromotionCreateSTR, '', '');
                dd = {
                    "promotion": {
                        "title": this.title,
                        "description": this.description,
                        "startDate": this.$moment(this.temp.startDate).format('YYYY-MM-DD'),
                        "endDate": this.$moment(this.temp.endDate).format('YYYY-MM-DD'),
                        "image": this.image,
                    },
                    "storeCode": this.$route.params.storeCode,
                }
            }
            reqPost(
                url,
                this.currentUser.tokens.access.token,
                dd,
                (result) => {
                    if (result != null) {
                        if (result.code === rescode.REQ_SUCCESS) {
                            alert('저장되었습니다.');
                            this.refresh();
                            this.promotionModalClose();
                        }
                    }
                }
            );
        },
        requrlChange(brdapiName, strapiName, brdquerystring, strquerystring) {
            let reqURL = ''
            if (this.currentUser.userRole.split('_')[0] == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + brdapiName) + brdquerystring
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + strapiName) + strquerystring
            }
            return reqURL
        }
    }
}
</script>

<style scoped>
.jetpo {
    justify-content: space-between;
    display: flex;
}

th {
    background-color: #dee2e685;
}

.right-btn {
    text-align: right;
}

.strongText {
    font-size: 18px;
}

.mt-6 {
    margin-top: 60px;
}

.changeInput {
    color: red;
    margin-top: 5px;
}

.btn-selweek {
    background-color: #5B9BD5;
    color: #FFFFFF;
}

.maxwidth {
    max-width: 200px;
    display: inline-block;
    vertical-align: middle;
}

.ml-1 {
    margin-left: 10px;

}

.mt-1,
.mt1 {
    margin-top: 10px;
}

.mt-2 {
    margin-top: 20px;
}

.bold {
    font-weight: 900;
}

.ml05 {
    margin-left: 5px;
}

.empty {
    color: #878787;
    font-size: 15px;
}

.mb-1 {
    margin-bottom: 10px;
}

.modal {
    overflow: auto;
}

.txtaH {
    height: 300px;
}
</style>
